import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const logScale = defineConnector({
  identifier: "logScale",
  name: "Falcon LogScale",
  tagLine: "Log management and observability platform",
  logo,
  protocol: "http",
  tags: ["observability", "security"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://cloud\\.community\\.humio\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In [LogScale](https://library.humio.com/), go to your profile in the top-right corner and select **API Token**. Copy the token.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "LogScale domain",
          required: true,
          placeholder: "cloud.community.humio.com",
          target: { kind: "configuration", field: "domain" },
          helperText:
            "Your LogScale instance hostname (e.g., `cloud.community.humio.com`).",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) =>
      `https://${domain || "cloud.community.humio.com"}/api/v1/status`,
  },
});
